import Scrollable from "../../../components/scrollable";
import List from "../../../components/list";
import ActivityItemNew from "../../../components/activity/activity-item-new";
import seamApi from "../../../lib/seam-api";
import { useEffect, useState } from "react";
import { stringToFriendlyDatetime } from "../../../lib/helpers/datetime-helpers";
import EmptyState from "../../../components/states/empty";

const LatestUpdates = () => {
    const [ updates, setUpdates ] = useState(null);

    const fetch = () => {
        seamApi.content().index({
            content_type_ids: [9],
            distribution_id: window.distribution_id,
        }).then(({ data }) => {
            setUpdates(data);
        });
    }

    useEffect(() => {
        fetch();
    }, [])

    if (updates?.length === 0 || updates === null) {
        return <EmptyState 
            loading={updates === null} 
            title="Updates" 
            description="There is no updates available" 
            titleColor="white"
            descriptionColor="white"
            showImage={false}
            style={{ minHeight: '300px' }}
        />
    }

    return (
        <Scrollable maxItems={6} itemHeight={111.73} spacing={20}>
            <List gap="20px">
                { updates?.map((update, index) => {
                    return (
                        <ActivityItemNew
                            key={index}
                            icon={false}
                            className="dashboard-activity-item"
                            subtitle={''}
                            title={update?.title}
                            body={stringToFriendlyDatetime(update?.published)}
                            onClick={() => window.location = `/mydmc/news/${update?.slug}`}
                        />
                    );
                }) }
            </List>
        </Scrollable>
    )
}

export default LatestUpdates;